/**
 * Created by christiancueni on 12/07/16.
 * Copyright (c) 2016 ITerativ GmbH. All rights reserved.
 */
import { Component } from "@angular/core";


@Component({
    selector: 'hc-impressum-page',
    template: `
    <div class="container-fluid">
      <div class="row bg-dark-blue products-title">
        <div class="col-md-10 col-md-offset-1">
            <div class="row">
                <div class="col-md-6 products-title__container">
                    <h1 class="qa-products-title main-title__heading inverted products-title__title">{{"Helloclass" | translate}}</h1>
                </div>
                <div class="col-md-6">
                    <div class="products-call2action">
                        <a routerLink="/signup" class="btn btn--yellow products-call2action__button">{{"Jetzt kostenlos registrieren" | translate}}</a>
                    </div>
                </div>
            </div>
        </div>
      </div><!-- end landing-title -->
      <div class="imprint row">
            <div class="col-md-10 col-md-offset-1">
                <h2>{{"Impressum" | translate}}</h2>
                <p [innerHtml]="about | translate"></p>
                <p [innerHtml]="scs | translate"></p>
                <h3>{{"Kontakt und Adresse" | translate}}</h3>
                <address class="imprint__contact">
<a href="mailto:sai.inbox@swisscom.com">Michael In Albon</a>
Swisscom (Schweiz) AG
Alte Tiefenaustrasse 6
3050 Bern
                </address>
            </div>
      </div>
      <div class="row footer-wrapper">
            <div class="col-md-10 col-md-offset-1">
                <hc-footer></hc-footer>
            </div>
        </div>
    </div>
    `
})
export class ImprintPage {

    public about = 'Das digitale Klassenbuch richtet sich an alle Schulen von der Unter- bis zur Oberstufe. Für Fragen und Bemerkungen wende Dich bitte an den <a href=\"https://helloclass.zendesk.com/hc/de/requests/new\">Support</a>.';
    public scs = 'Helloclass wird im Auftrag der <a href=\"http://swisscom.com\">Swisscom (Schweiz) AG entwickelt und betrieben.';
    constructor() { }

}
